<template>
  <v-dialog
    content-class="contact-stay-control-quiz-dialog"
    :value="true"
    :transition="false"
    @click:outside="closeDialog"
    @keydown.esc="closeDialog"
  >
    <v-card>
      <v-container class="px-8 pt-6 pb-4 contact-stay-control-quiz-restriction-dialog-container">
        <v-card-text class="pa-0 contact-control-quiz-dialog-title-restriction">
          {{ $t('dialogs.changeContact.title') }}
        </v-card-text>
        <v-btn
          icon
          width="fit-content"
          height="fit-content"
          class="contact-stay-control-quiz-restriction-dialog-close-button"
          @click="closeDialog"
        >
          <close-icon class="stay-control-quiz-dialog-close-icon" />
        </v-btn>
      </v-container>

      <div class="contact-change-control-quiz-messenger-container">
        <div class="px-8 contact-control-quiz-messenger-text">
          {{ $t('dialogs.changeContact.description', {date: firstDayOfNextMonth}) }}
        </div>
          <v-btn
            small
            rounded
            outlined
            color="primary"
            class="ml-8 mb-7 mt-5 py-3 px-5 contact-control-quiz-messenger-close-btn"
            @click="closeDialog"
          >
            {{ $t('common.close') }}
          </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import CloseIcon from '@/assets/svgIcons/closeIcon.svg?inline'
import moment from 'moment';

export default {
  name: "ContactChangeRestrictionDialog",
  components: {
    CloseIcon
  },

  computed: {
    firstDayOfNextMonth() {
      return moment().add(1, 'months').startOf('month').format('D MMMM YYYY')
    }
  },

  methods: {
    closeDialog () {
      this.$emit("closeContactRestrictionDialog");
    }
  },
};
</script>

<style lang="scss" scoped>
.contact-change-control-quiz-messenger-container .contact-control-quiz-messenger-close-btn {
  height: 36px;
}

.contact-stay-control-quiz-restriction-dialog-container {
  display: flex;
  align-items: center;
  gap: 16px;
}

.contact-control-quiz-messenger-text {
  color: var(--v-text-secondary-base);
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.contact-stay-control-quiz-restriction-dialog-close-button {
  fill: var(--v-old-icon-button-outline-secondary-foreground-default-base);
  right: 16px;
  padding: 5px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  position: absolute;
  top: 16px;
}

.contact-control-quiz-dialog-title-restriction {
  display: flex;
  flex-direction: row;
  max-width: 410px;
  align-items: center;
  color: var(--v-text-primary-base);
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: normal;
  font-family: Roboto,serif;
}
</style>
